import { useEffect, useMemo } from 'react';
import useRouteStages from '@/context/stages/hook';
import { stagesService } from '@/services/stages';

interface Props {
  routeId?: string;
  stageId?: string;
}

const useLoadStage = ({ routeId, stageId }: Props) => {
  const { getStage, loadStage } = useRouteStages();

  const stage = useMemo(() => getStage(routeId as string, stageId as string), [getStage, routeId, stageId]);

  useEffect(() => {
    if (!routeId || !stageId) return;
    stagesService.getStage(stageId).then((stage) => {
      loadStage(routeId, stageId, stage);
    });
  }, [loadStage, routeId, stageId]);

  return { stage };
};

export default useLoadStage;
